import SectionSustainability from 'components/section/sustainability';
import Url from 'lib/siteurls';
import CartLocale from 'locale/en/cart.json';
import MiscLocale from 'locale/en/misc.json';
import PdpLocale from 'locale/en/pdp.json';
import { PRODUCT_SKUS } from 'lib/constants/product-skus';

const cobioticsThreeMonth = (sku: string, slug: string, image: string) => ({
  cmsSlug: slug,
  pdpUrl: `/${slug}`,
  buyUrl: `/cart?cart=${sku}`,
  sku,
  image,
  cartImage: image,
  name: slug,
  supplyLengthInDays: 90,
  supplyLengthInMonths: '3 months',
  couponOverrideMessage: 'Save 10% forever',
});

/*
These configurations are basic Product attributes that will help the Partner page
retrieve product content (from Contentful) and render the Product (ie. sectionSustainabilityFormComponent)

The Partner page will look up the product via the "sku" query parameter and use the associated configuraiton (default is 'syn-wk').
*/

const ProductData = {
  [PRODUCT_SKUS.DAILY_SYNBIOTIC]: {
    cmsContentType: 'page',
    cmsSlug: 'daily-synbiotic',
    name: 'daily-synbiotic',
    buyUrl: `/cart?cart=${PRODUCT_SKUS.DAILY_SYNBIOTIC}`,
    pdpUrl: '/daily-synbiotic',
    sku: PRODUCT_SKUS.DAILY_SYNBIOTIC,
    sectionBenefit: 'pdp--benefits',
    sectionEngineered: 'pdp--engineered',
    sectionFormulation: 'pdp--formulation',
    sectionProbioticsTable: 'pdp--probiotics-table',
    sectionNewStandard: 'pdp--standard',
    sectionSustainability: 'daily-synbiotic--sustainability',
    sectionCurious: 'pdp--curious',
    siteBuyCode: 'daily-synbiotic',
    srp0PdpDescription: 'Billed every month.',
    cartImage: `https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1693433672/cart/DS01_2x.png`,
    cartSummaryImage: `https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1605775788/sustainability/image_152_ssz7y1.png`,
    upsell: {
      nyDiscountAmt: 20,
      discountAmt: 12.5,
      shortName: 'DS-01®',
      cartImageUrl: `${Url.cloudinary}/f_auto,q_auto/v1693433672/cart/DS01_2x.png`,
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1610475400/daily-synbiotic/Seed_PDP_01_Hero_Mobile_1_NEW.jpg`,
      imageAlt: 'DS-01® Jar',
      title: 'DS-01® Daily Synbiotic',
      description:
        'Our proprietary formulation contains 24 clinically and scientifically studied, broad spectrum strains to support systemic health.',
      detail: '',
      learnMoreCTA: MiscLocale.learn_more,
      header: 'For you',
      whoFor: 'For Adults (18+)',
      displayOrder: 1,
      priceFrequency: ' / month',
    },
    crossSell: {
      description: 'Gut Health for Adults 18+',
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1728311015/cross-sell-module/cross-sell-ds.png`,
      title: 'DS-01® Daily Synbiotic',
      monthlyText: 'per month',
      backgroundColor: `var(--fill-neutral-light)`,
    },
    bonusProducts: [
      {
        name: 'jar',
        className: 'jar',
        imageUrl: `https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1693433672/cart/DS01_2x.png`,
        title: CartLocale.glass_jar,
        price: CartLocale.free,
        subTitle: 'Bonus gift',
        quantity: 1,
        shortName: 'DS-01®',
      },
      {
        name: 'vial',
        className: 'vial',
        imageUrl: `${Url.cloudinary}/f_auto,q_auto/Seed_Vial_Studio__500x_1_n9v8hg.png`,
        title: CartLocale.glass_travel,
        price: CartLocale.free,
        subTitle: CartLocale.so_you,
        quantity: 1,
        shortName: 'DS-01®',
      },
    ],
    numCapsules: 60,
    supplyLengthInDays: 30,
    supplyLengthInMonths: 'month',
    couponOverrideMessage: '',
  },
  'syn-wk-duo': {
    cmsContentType: 'page',
    cmsSlug: 'daily-synbiotic',
    name: 'daily-synbiotic',
    buyUrl: `/cart?cart=${PRODUCT_SKUS.DAILY_SYNBIOTIC}`,
    pdpUrl: '/daily-synbiotic',
    sku: PRODUCT_SKUS.DAILY_SYNBIOTIC,
    sectionBenefit: 'pdp--benefits',
    sectionEngineered: 'pdp--engineered',
    sectionFormulation: 'pdp--formulation',
    sectionProbioticsTable: 'pdp--probiotics-table',
    sectionNewStandard: 'pdp--standard',
    sectionSustainability: 'daily-synbiotic--sustainability',
    sectionCurious: 'pdp--curious',
    siteBuyCode: 'daily-synbiotic',
    srp0PdpDescription: 'Billed every month.',
    upsell: {
      shortName: 'DS-01®',
      cartImageUrl: `${Url.cloudinary}/f_auto,q_auto/v1699417662/cart/DS01_2x.png`,
      cartImageUrl2: `${Url.cloudinary}/f_auto,q_auto/v1693433672/daily-synbiotic/Duo-2.png`,
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1610475400/daily-synbiotic/Seed_PDP_01_Hero_Mobile_1_NEW.jpg`,
      imageAlt: 'DS-01® Jar',
      title: 'DS-01® Daily Synbiotic Duo',
      description:
        'Our proprietary formulation contains 24 clinically and scientifically studied, broad spectrum strains to support systemic health.',
      detail: '',
      learnMoreCTA: MiscLocale.learn_more,
      header: 'For double the DS-01®',
      whoFor: 'For Adults (18+)',
      discountAmt: 10,
      displayOrder: 2,
    },
    bonusProducts: [
      {
        name: 'jar',
        className: 'jar',
        imageUrl: `https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1693433672/cart/DS01_2x.png`,
        title: CartLocale.glass_jar,
        price: CartLocale.free,
        subTitle: 'Bonus gift',
        quantity: 1,
        shortName: 'DS-01®',
      },
      {
        name: 'vial',
        className: 'vial',
        imageUrl: `${Url.cloudinary}/f_auto,q_auto/Seed_Vial_Studio__500x_1_n9v8hg.png`,
        title: CartLocale.glass_travel,
        price: CartLocale.free,
        subTitle: CartLocale.so_you,
        quantity: 1,
        shortName: 'DS-01®',
      },
    ],
    numCapsules: 60,
    supplyLengthInDays: 30,
    supplyLengthInMonths: 'month',
    couponOverrideMessage: '',
  },
  [PRODUCT_SKUS.DAILY_SYNBIOTIC_ONE_TIME]: {
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755883106/cart/DS-01_80x80.png',
    cmsContentType: 'page',
    cmsSlug: 'daily-synbiotic',
    name: 'daily-synbiotic',
    buyUrl: `/cart?cart=${PRODUCT_SKUS.DAILY_SYNBIOTIC_ONE_TIME}`,
    pdpUrl: '/daily-synbiotic',
    sku: PRODUCT_SKUS.DAILY_SYNBIOTIC_ONE_TIME,
  },
  'syn-wk-3mo': {
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1693433672/cart/DS01_2x.png',
    cmsContentType: 'page',
    cmsSlug: 'daily-synbiotic',
    name: 'daily-synbiotic',
    buyUrl: '/cart?cart=syn-wk-3mo',
    pdpUrl: '/daily-synbiotic',
    sku: 'syn-wk-3mo',
    sectionBenefit: 'pdp--benefits',
    sectionEngineered: 'pdp--engineered',
    sectionFormulation: 'pdp--formulation',
    sectionProbioticsTable: 'pdp--probiotics-table',
    sectionNewStandard: 'pdp--standard',
    sectionSustainability: 'daily-synbiotic--sustainability',
    sectionCurious: 'pdp--curious',
    siteBuyCode: 'daily-synbiotic',
    srp0PdpDescription: 'Billed $134.97 every 3 months.',
    upsell: {
      shortName: 'DS-01®',
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1610475400/daily-synbiotic/Seed_PDP_01_Hero_Mobile_1_NEW.jpg`,
      imageAlt: 'DS-01® Jar',
      title: 'DS-01® Daily Synbiotic',
      description:
        'Our proprietary formulation contains 24 clinically and scientifically studied, broad spectrum strains to support systemic health.',
      detail: '',
      learnMoreCTA: MiscLocale.learn_more,
      header: 'For you',
    },
    bonusProducts: [
      {
        name: 'jar',
        className: 'jar',
        imageUrl: `https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1693433672/cart/DS01_2x.png`,
        title: CartLocale.glass_jar,
        price: CartLocale.free,
        subTitle: 'Bonus gift',
        quantity: 1,
        shortName: 'DS-01®',
      },
      {
        name: 'vial',
        className: 'vial',
        imageUrl: `${Url.cloudinary}/f_auto,q_auto/Seed_Vial_Studio__500x_1_n9v8hg.png`,
        title: CartLocale.glass_travel,
        price: CartLocale.free,
        subTitle: CartLocale.so_you,
        quantity: 1,
        shortName: 'DS-01®',
      },
    ],
    numCapsules: 180,
    supplyLengthInDays: 90,
    supplyLengthInMonths: '3 months',
    couponOverrideMessage: 'Save 10% forever',
  },
  'syn-wk-6mo': {
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1693433672/cart/DS01_2x.png',
    cmsContentType: 'page',
    cmsSlug: 'daily-synbiotic',
    name: 'daily-synbiotic',
    buyUrl: '/cart?cart=syn-wk-6mo',
    pdpUrl: '/daily-synbiotic',
    sku: 'syn-wk-6mo',
    sectionBenefit: 'pdp--benefits',
    sectionEngineered: 'pdp--engineered',
    sectionFormulation: 'pdp--formulation',
    sectionProbioticsTable: 'pdp--probiotics-table',
    sectionNewStandard: 'pdp--standard',
    sectionSustainability: 'daily-synbiotic--sustainability',
    sectionCurious: 'pdp--curious',
    siteBuyCode: 'daily-synbiotic',
    srp0PdpDescription: 'Billed $254.94 every 6 months.',
    upsell: {
      shortName: 'DS-01®',
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1610475400/daily-synbiotic/Seed_PDP_01_Hero_Mobile_1_NEW.jpg`,
      imageAlt: 'DS-01® Jar',
      title: 'DS-01® Daily Synbiotic',
      description:
        'Our proprietary formulation contains 24 clinically and scientifically studied, broad spectrum strains to support systemic health.',
      detail: '',
      learnMoreCTA: MiscLocale.learn_more,
      header: 'For you',
    },
    bonusProducts: [
      {
        name: 'jar',
        className: 'jar',
        imageUrl: `https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1693433672/cart/DS01_2x.png`,
        title: CartLocale.glass_jar,
        price: CartLocale.free,
        subTitle: 'Bonus gift',
        quantity: 1,
        shortName: 'DS-01®',
      },
      {
        name: 'vial',
        className: 'vial',
        imageUrl: `${Url.cloudinary}/f_auto,q_auto/Seed_Vial_Studio__500x_1_n9v8hg.png`,
        title: CartLocale.glass_travel,
        price: CartLocale.free,
        subTitle: CartLocale.so_you,
        quantity: 1,
        shortName: 'DS-01®',
      },
    ],
    numCapsules: 360,
    supplyLengthInDays: 180,
    supplyLengthInMonths: '6 months',
    couponOverrideMessage: 'Save 15% forever',
  },
  [PRODUCT_SKUS.DAILY_SYNBIOTIC_REFILL]: {
    cmsContentType: 'page',
    cmsSlug: 'daily-synbiotic-refill',
    name: 'daily-synbiotic-refill',
    pdpUrl: '/daily-synbiotic-refill',
    buyUrl: `/cart?cart=${PRODUCT_SKUS.DAILY_SYNBIOTIC_REFILL}`,
    sku: PRODUCT_SKUS.DAILY_SYNBIOTIC_REFILL,
    titleLocale: PdpLocale.daily_synbiotic_refill_markup_small,
    sectionHero: 'daily-synbiotic-refill--hero',
    sectionBenefit: 'pdp--benefits',
    sectionEngineered: 'pdp--engineered',
    sectionFormulation: 'pdp--formulation',
    sectionProbioticsTable: 'pdp--probiotics-table',
    sectionNewStandard: 'pdp--standard',
    sectionSustainability: 'daily-synbiotic-refill--sustainability',
    sectionCurious: 'pdp--curious',
    sectionSustainabilityFormComponent: SectionSustainability,
    // each element in the slidesClasses is a list of classes for the slide
    slidesClasses: [['no-background'], [], []],
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,ar_1:1,c_fill,h_512,q_100/v1742588403/ds-01-refill-cart.jpg',
    image:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,ar_1:1,c_fill,h_512,q_100/v1742588403/ds-01-refill-cart.jpg',
  },
  'pds-gwp': {
    cmsContentType: 'page',
    cmsSlug: 'daily-pediatric',
  },
  [PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC]: {
    cmsContentType: 'page',
    cmsSlug: 'pds08-daily-kids-probiotic',
    buyUrl: Url.buy_pds08,
    pdpUrl: Url.pediatric_daily,
    siteBuyCode: 'pds-08',
    cartImage: `${Url.cloudinary}/f_auto,q_auto/v1649806954/PDS-08_Sachet.png`,
    upsell: {
      discountAmt: 10,
      nyDiscountAmt: 16,
      cartImageUrl: `${Url.cloudinary}/f_auto,q_auto/v1693433672/cart/PDS08_2x.png`,
      imageUrl:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1659049058/pediatric-daily-synbiotic/PDS-01-img3.jpg',
      imageAlt: 'PDS-08 Jar',
      title: 'PDS-08® Pediatric Daily Synbiotic',
      description:
        'Our mission to steward the next generation of probiotics continues with PDS-08®, our first pediatric innovation for children and adolescents—a 2-in-1 powdered synbiotic with 9 clinically studied probiotic strains and a prebiotic blend.',
      detail:
        'ALL ingredients and their included dosages have been specifically studied in a pediatric population.',
      learnMoreCTA: MiscLocale.learn_more,
      shortName: 'PDS-08®',
      header: 'For the kids',
      whoFor: 'For Kids + Teens (3-17)',
      displayOrder: 5,
      priceFrequency: ' / month',
    },
    crossSell: {
      description: 'Gut Health for Kids 3+',
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1728660991/cross-sell-module/cross-sell-pds.png`,
      title: 'PDS-08® Pediatric Daily Synbiotic',
      monthlyText: 'per month',
      backgroundColor: `var(--guidance-secondary)`,
    },
    bonusProducts: [
      {
        name: 'vial',
        className: 'vial',
        imageUrl:
          'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1649199881/PDS%20PDP/Seed-Bactrac-onwhite.png',
        title: 'Refillable Aluminum BacTrac™ Container',
        price: CartLocale.free,
        subTitle: CartLocale.store_your_sachets,
        quantity: 1,
      },
    ],
  },
  [PRODUCT_SKUS.PDS08_DAILY_KIDS_PROBIOTIC_REFILL]: {
    cmsContentType: 'page',
    cmsSlug: 'pds08-daily-kids-probiotic-refill',
    buyUrl: Url.buy_pds08_refill,
    pdpUrl: Url.pediatric_daily,
    siteBuyCode: 'pds-08',
  },
  [PRODUCT_SKUS.VAGINAL_SYNBIOTIC]: {
    cmsContentType: 'page',
    cmsSlug: 'vaginal-synbiotic',
    pdpUrl: Url.vaginal_synbiotic,
    name: 'vaginal-synbiotic',
    buyUrl: `/cart?cart=${PRODUCT_SKUS.VAGINAL_SYNBIOTIC}`,
    sku: PRODUCT_SKUS.VAGINAL_SYNBIOTIC,
    siteBuyCode: 'vaginal-synbiotic',
    srp0PdpDescription: 'Billed every month.',
    cartImage: `${Url.cloudinary}/f_auto,q_auto/v1722005136/Channel%20Catalogs/1_1_VS-01_2x.jpg`,
    upsell: {
      discountAmt: 24.75,
      nyDiscountAmt: 39.6,
      shortName: 'VS-01™ 2 Month Starter Kit',
      cartImageUrl: `${Url.cloudinary}/f_auto,q_auto/v1716221232/cart/VS_cart.png`,
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1715203752/vs-01/D1_-_16_-_Combo_Starter_Kit_Closed_3Q_Applicator_Tablet_Alpha.png`,
      imageAlt: 'VS-01™ Jar',
      title: 'VS-01™ 2 Month Starter Kit',
      description:
        'Our two-step Reset + Sustain protocol ensures an optimal vaginal microbiome (VMB) and balanced pH, protecting against daily disruptors. Clinically validated, our VS-01™ is a proactive care journey for a liberated life.',
      detail: '',
      learnMoreCTA: MiscLocale.learn_more,
      header: 'For you',
      whoFor: 'Vaginal Synbiotic',
      displayOrder: 6,
      priceFrequency: '',
    },
    crossSell: {
      description: 'Vaginal Health',
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1728661015/cross-sell-module/cross-sell-vs.png`,
      title: 'VS-01™ 2 Month Starter Kit',
      monthlyText: 'every month after',
      backgroundColor: `#D4E2E2`,
    },
    numCapsules: 60,
    supplyLengthInDays: 30,
    supplyLengthInMonths: 'month',
    couponOverrideMessage: '',
  },
  [PRODUCT_SKUS.VAGINAL_SYNBIOTIC_SUSTAIN]: {
    cmsContentType: 'page',
    cmsSlug: 'vaginal-synbiotic',
    pdpUrl: Url.vaginal_synbiotic,
    name: 'vaginal-synbiotic',
    buyUrl: `/cart?cart=${PRODUCT_SKUS.VAGINAL_SYNBIOTIC_SUSTAIN}`,
    sku: PRODUCT_SKUS.VAGINAL_SYNBIOTIC_SUSTAIN,
    siteBuyCode: 'vaginal-synbiotic',
    srp0PdpDescription: 'Billed every month.',
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,ar_1:1,c_fill,h_512,q_100/v1742412145/vs-rf-hero.png',
    image:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,ar_1:1,c_fill,h_512,q_100/v1742412145/vs-rf-hero.png',
    upsell: {
      shortName: 'VS-01™ Monthly Sustain',
      cartImageUrl: `${Url.cloudinary}/f_auto,q_auto/v1716221232/cart/VS_cart.png`,
      imageUrl: `${Url.cloudinary}/f_auto,q_auto/v1715203752/vs-01/D1_-_16_-_Combo_Starter_Kit_Closed_3Q_Applicator_Tablet_Alpha.png`,
      imageAlt: 'VS-01™ Jar',
      title: 'VS-01™ Monthly Sustain',
      description:
        'Our two-step Reset + Sustain protocol ensures an optimal vaginal microbiome (VMB) and balanced pH, protecting against daily disruptors. Clinically validated, our VS-01™ is a proactive care journey for a liberated life.',
      detail: '',
      learnMoreCTA: MiscLocale.learn_more,
      header: 'For you',
      whoFor: 'Vaginal Synbiotic',
      displayOrder: 6,
      priceFrequency: '',
    },
    numCapsules: 30,
    supplyLengthInDays: 30,
    supplyLengthInMonths: 'month',
    couponOverrideMessage: '',
  },
  [PRODUCT_SKUS.ENERGY_FOCUS]: {
    cmsSlug: 'energy-focus',
    pdpUrl: '/energy-focus',
    image:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/am02-cross-sell.png',
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/am02-cross-sell.png',
    name: 'energy-focus',
    upsell: {
      title: 'AM-02® Energy + Focus',
      discountAmt: 8.75,
      nyDiscountAmt: 14,
      // delete prop after NPD launch
      imageAlt: 'AM-02 Jar',
      displayOrder: 3,
      cartImageUrl:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/am02-cross-sell.png',
      imageUrl:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/am02-cross-sell.png',
      accountDiscountAmt: 8.74,
    },
  },
  [PRODUCT_SKUS.DAILY_MULTIVITAMIN]: {
    cmsSlug: 'daily-multivitamin',
    pdpUrl: '/daily-multivitamin',
    image:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/dm02-cross-sell.png',
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/dm02-cross-sell.png',
    name: 'daily-multivitamin',
    upsell: {
      displayOrder: 2,
      discountAmt: 10,
      nyDiscountAmt: 16,

      // delete prop after NPD launch
      title: 'DM-02® Daily Multivitamin',
      imageAlt: 'DM-02 Jar',
      cartImageUrl:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/dm02-cross-sell.png',
      imageUrl:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/dm02-cross-sell.png',
      accountDiscountAmt: 9.99,
    },
  },
  [PRODUCT_SKUS.SLEEP_RESTORE]: {
    cmsSlug: 'sleep-restore',
    pdpUrl: '/sleep-restore',
    image:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802719/cross-sell-module/pm02-cross-sell.png',
    cartImage:
      'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802719/cross-sell-module/pm02-cross-sell.png',
    name: 'sleep-restore',
    upsell: {
      displayOrder: 4,
      discountAmt: 8.75,
      nyDiscountAmt: 14,
      // delete prop after NPD launch
      title: 'PM-02® Sleep + Restore',
      imageAlt: 'PM-02 Jar',
      cartImageUrl:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802719/cross-sell-module/pm02-cross-sell.png',
      imageUrl:
        'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802719/cross-sell-module/pm02-cross-sell.png',
      accountDiscountAmt: 8.74,
    },
  },
  [PRODUCT_SKUS.ENERGY_FOCUS_3MO]: cobioticsThreeMonth(
    PRODUCT_SKUS.ENERGY_FOCUS_3MO,
    'energy-focus',
    'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/am02-cross-sell.png',
  ),
  [PRODUCT_SKUS.DAILY_MULTIVITAMIN_3MO]: cobioticsThreeMonth(
    PRODUCT_SKUS.DAILY_MULTIVITAMIN_3MO,
    'daily-multivitamin',
    'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802720/cross-sell-module/dm02-cross-sell.png',
  ),
  [PRODUCT_SKUS.SLEEP_RESTORE_3MO]: cobioticsThreeMonth(
    PRODUCT_SKUS.SLEEP_RESTORE_3MO,
    'sleep-restore',
    'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755802719/cross-sell-module/pm02-cross-sell.png',
  ),
  'ds-duo': {
    cmsContentType: 'page',
    cmsSlug: 'daily-essentials-duo',
    name: 'daily-essentials-duo',
    buyUrl: `/cart?cart=${PRODUCT_SKUS.DAILY_SYNBIOTIC},${PRODUCT_SKUS.DAILY_MULTIVITAMIN}`,
    pdpUrl: '/daily-essentials-duo',
    sku: 'ds-duo',
    siteBuyCode: 'daily-essentials-duo',
  },
};

export default ProductData;

export const PRODUCT_IMAGE_DS01 =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487644/library/nav/shop/DS01.png';
export const PRODUCT_IMAGE_DM02 =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755803988/library/nav/shop/DM02.png';
export const PRODUCT_IMAGE_DED =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755804034/library/nav/shop/DED.png';
export const PRODUCT_IMAGE_AM02 =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755804048/library/nav/shop/AM02.png';
export const PRODUCT_IMAGE_PM02 =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755804062/library/nav/shop/PM02.png';
export const PRODUCT_IMAGE_PDS08 =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487661/library/nav/shop/PDS08.png';
export const PRODUCT_IMAGE_VS01 =
  'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1755487654/library/nav/shop/VS01.png';
